import { render, staticRenderFns } from "./SignUpEmail.vue?vue&type=template&id=06f720d8&scoped=true"
import script from "./SignUpEmail.vue?vue&type=script&lang=js"
export * from "./SignUpEmail.vue?vue&type=script&lang=js"
import style0 from "./SignUpEmail.vue?vue&type=style&index=0&id=06f720d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f720d8",
  null
  
)

export default component.exports